// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__fCng4","bigColWidth":"Table_bigColWidth__32j_5","biggerColWidth":"Table_biggerColWidth__MEmko","row":"Table_row__A9hZ7","col":"Table_col__AZLB_"};